import { useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"

export function useDeleteSavedReportMutation() {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const mutation = useMutation(
    ['delete-saved-report'],
    async (savedReportId: string) => {

      const response = await apiClient.delete(`/saved_reports/${savedReportId}`)

      if (!response.ok) {
        throw response.errors
      }

      return response.savedReport
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['saved-reports'])
      }
    }
 
  )

  return mutation
}